export default __webpack_public_path__ + "static/media/25120412.71e2e37f.jpg";